<template>
  <section class="step1">
    <div class="col-sm-12">
      <div class="quiz_content_area">
        <div class="row justify-content-center">
          <div class="col-sm-3">
            <div class="quiz_card_area">
              <input
                class="quiz_checkbox"
                type="radio"
                value="sms"
                v-model="message.type"
                @input="changeMessageType"
              />
              <div class="single_quiz_card">
                <div class="quiz_card_content">
                  <div class="quiz_card_icon">
                    <div class="quiz_icon quiz_icon1"></div>
                  </div>
                  <div class="quiz_card_title">
                    <h3>
                      <i v-if="message.type === 'sms'" class="fa fa-check" aria-hidden="true"></i>
                      {{ __('message_interface.step1.send_sms') }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="quiz_card_area">
              <input
                class="quiz_checkbox"
                type="radio"
                v-model="message.type"
                value="email"
                name="choix"
                @input="changeMessageType"
              />
              <div class="single_quiz_card">
                <div class="quiz_card_content">
                  <div class="quiz_card_icon">
                    <div class="quiz_icon quiz_icon2"></div>
                  </div>

                  <div class="quiz_card_title">
                    <h3>
                      <i v-if="message.type === 'email'" class="fa fa-check" aria-hidden="true"></i>
                      {{ __('message_interface.step1.send_mail') }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <button
        class="btn btn-primary float-right"
        @click="$emit('next-tab')"
        :disabled="message.type == ''"
      >
        {{ __('message_interface.btns.next') }}
      </button>
    </div>
    <div class="clearfix"></div>
  </section>
</template>

<script>
export default {
  name: 'MessageType',
  props: {
    message: {
      type: Object,
      default() {
        return {
          type: '',
          model: '',
          messageToSend: null,
          messageSubject: '',
          selectedMessageModel: {
            id: null,
            name: null,
            content: null,
            subject: null
          },
          selectedClient: null,
          options: {
            mail: {},
            sms: {}
          },
          sent: false,
          loading: false
        }
      }
    }
  },
  methods: {
    changeMessageType() {
      this.message.messageToSend = null
      this.message.selectedMessageModel = {
        id: null,
        name: null,
        content: null,
        subject: null
      }
      this.message.model = ''
    }
  }
}
</script>
